import { ConfigParams } from './params';

declare const __WEBPAKC_ROOTPATH__: string;
declare const __WEBPAKC_LOGGING_ROUTER__: boolean;
declare const __WEBPACK_LOGOUT_URL__: string;
declare const __WEBPACK_AUTH_GRANT_TYPE__: string | undefined;
declare const __WEBPACK_OIDC_CLIENT_ID__: string | undefined;
declare const __WEBPACK_OIDC_CLIENT_SECRET__: string | undefined;
declare const __WEBPACK_OIDC_AUTH_FLOW__: string | undefined;
declare const __WEBPACK_OIDC_ISSUER__: string | undefined;
declare const __WEBPACK_OIDC_AUTH_ENDPOINT__: string | undefined;
declare const __WEBPACK_OIDC_TOKEN_ENDPOINT__: string | undefined;
declare const __WEBPACK_OIDC_END_SESSION_ENDPOINT__: string | undefined;
declare const __WEBPACK_OIDC_AUTH_CB_URI__: string | undefined;
declare const __WEBPACK_OIDC_END_SESSION_CAN_REDIRECT__: boolean | undefined;
declare const __WEBPACK_AUTH_API_BASEURL__: string | undefined;
declare const __WEBPACK_VEHICLE_API_BASEURL__: string | undefined;
declare const __WEBPACK_CONTROL_API_BASEURL__: string | undefined;
declare const __WEBPACK_CONTROL_API_STREAM_URL__: string | undefined;
declare const __WEBPACK_MONITOR_API_BASEURL__: string | undefined;
declare const __WEBPACK_MONITOR_API_STREAM_URL__: string | undefined;
declare const __WEBPACK_ROLE_API_BASEURL__: string | undefined;
declare const __WEBPACK_FMS_API_BASEURL__: string | undefined;
declare const __WEBPACK_FMS_API_STREAM_URL__: string | undefined;
declare const __WEBPACK_SENTRY_DSN__: string | undefined;
declare const __WEBPACK_SENTRY_ENV__: string | undefined;
declare const __WEBPACK_GA_TRACKING_ID__: string | undefined;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
(window as any).__WEBPACK_AUTH_GRANT_TYPE__ = 'urn:ietf:params:oauth:grant-type:token-exchange';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
(window as any).__WEBPACK_OIDC_ISSUER__ = undefined;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
(window as any).__WEBPACK_OIDC_AUTH_ENDPOINT__ = undefined;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
(window as any).__WEBPACK_OIDC_TOKEN_ENDPOINT__ = undefined;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
(window as any).__WEBPACK_OIDC_AUTH_CB_URI__ = undefined;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
(window as any).__WEBPACK_OIDC_END_SESSION_CAN_REDIRECT__ = undefined;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
(window as any).__WEBPACK_OIDC_END_SESSION_ENDPOINT__ = undefined;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
(window as any).__WEBPACK_SENTRY_DSN__ = undefined;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
(window as any).__WEBPACK_SENTRY_ENV__ = undefined;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
(window as any).__WEBPACK_GA_TRACKING_ID__ = undefined;

const oidc = __WEBPACK_OIDC_ISSUER__
    && __WEBPACK_OIDC_CLIENT_ID__ && __WEBPACK_OIDC_CLIENT_SECRET__
    && __WEBPACK_OIDC_AUTH_FLOW__
    ? {
        issuer: __WEBPACK_OIDC_ISSUER__,
        authEndpoint: __WEBPACK_OIDC_AUTH_ENDPOINT__,
        tokenEndpoint: __WEBPACK_OIDC_TOKEN_ENDPOINT__,
        endSessionEnpoint: __WEBPACK_OIDC_END_SESSION_ENDPOINT__,
        clientId: __WEBPACK_OIDC_CLIENT_ID__,
        clientSecret: __WEBPACK_OIDC_CLIENT_SECRET__,
        flow: __WEBPACK_OIDC_AUTH_FLOW__,
        redirectUri: __WEBPACK_OIDC_AUTH_CB_URI__,
        endSessionCanRedirect: __WEBPACK_OIDC_END_SESSION_CAN_REDIRECT__ !== undefined ? __WEBPACK_OIDC_END_SESSION_CAN_REDIRECT__ : true,
    }
    : undefined;

const auth = oidc ? { oidc, grantType: __WEBPACK_AUTH_GRANT_TYPE__ } : undefined;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
(window as any).__WEBPACK_AUTH_API_BASEURL__ = undefined;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
(window as any).__WEBPACK_LOGOUT_URL__ = '/';

const servers = __WEBPACK_AUTH_API_BASEURL__
    && __WEBPACK_VEHICLE_API_BASEURL__
    && __WEBPACK_MONITOR_API_BASEURL__ && __WEBPACK_MONITOR_API_STREAM_URL__
    && __WEBPACK_CONTROL_API_BASEURL__ && __WEBPACK_CONTROL_API_STREAM_URL__
    && __WEBPACK_ROLE_API_BASEURL__
    && __WEBPACK_FMS_API_BASEURL__ && __WEBPACK_FMS_API_STREAM_URL__
    ? {
        auth: {
            baseUrl: __WEBPACK_AUTH_API_BASEURL__,
        },
        vehicle: {
            baseUrl: __WEBPACK_VEHICLE_API_BASEURL__,
        },
        monitor: {
            baseUrl: __WEBPACK_MONITOR_API_BASEURL__,
            streamBaseUrl: __WEBPACK_MONITOR_API_STREAM_URL__
        },
        control: {
            baseUrl: __WEBPACK_CONTROL_API_BASEURL__,
            streamBaseUrl: __WEBPACK_CONTROL_API_STREAM_URL__
        },
        role: {
            baseUrl: __WEBPACK_ROLE_API_BASEURL__,
        },
        fms: {
            baseUrl: __WEBPACK_FMS_API_BASEURL__,
            streamBaseUrl: __WEBPACK_FMS_API_STREAM_URL__,
        },
    }
    : undefined;

const sentry = __WEBPACK_SENTRY_DSN__
    ? {
        dsn: __WEBPACK_SENTRY_DSN__,
        environment: __WEBPACK_SENTRY_ENV__
    }
    : undefined;

const ga = __WEBPACK_GA_TRACKING_ID__
    ? {
        trackingId: __WEBPACK_GA_TRACKING_ID__,
    }
    : undefined;

export const WebpackConfig: ConfigParams = {
    deployment: {
        rootPath: __WEBPAKC_ROOTPATH__,
        logoutUrl: __WEBPACK_LOGOUT_URL__,
    },
    logging: {
        router: __WEBPAKC_LOGGING_ROUTER__,
    },
    auth,
    servers,
    sentry,
    ga,
};
